/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selectacountry2Inputs */

const en_selectacountry2 = /** @type {(inputs: Selectacountry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a country`)
};

const de_selectacountry2 = /** @type {(inputs: Selectacountry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl ein Land`)
};

/**
* | output |
* | --- |
* | "Select a country" |
*
* @param {Selectacountry2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const selectacountry2 = /** @type {((inputs?: Selectacountry2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selectacountry2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_selectacountry2(inputs)
	return de_selectacountry2(inputs)
});
export { selectacountry2 as "selectACountry" }